<template lang="pug">
  b-modal#editBankAccount(
  ref="editBankAccount"
  :title="$t('ui.combine.edit_bank_account')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$tc('ui.banks', 1)" disabled).mb-0
        BankLookup(
          ref="bank"
          size="sm"
          required
          type="array"
          :dirty="$v.bank.$dirty"
          :error="$v.bank.$error"
          v-model.trim.lazy="$v.bank.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
      b-form-group(:label="$t('ui.bank_acc_no')" disabled).mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.bank_acc_no.$dirty"
          :error="$v.bank_acc_no.$error"
          v-model.trim.lazy="$v.bank_acc_no.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')")
      b-form-group(:label="$tc('ui.bank_acc_holder')").mb-0
        DebounceInput(
          size="sm"
          ref="bank_acc_holder"
          required
          type="text"
          :dirty="$v.bank_acc_holder.$dirty"
          :error="$v.bank_acc_holder.$error"
          v-model.trim.lazy="$v.bank_acc_holder.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.bank_acc_holder" :name="$t('ui.bank_acc_holder')")
      b-form-group(:label="$t('ui.bank_acc_type')").mb-0
        BankAccType(
          size="sm"
          required
          type="array"
          :dirty="$v.bank_acc_type.$dirty"
          :error="$v.bank_acc_type.$error"
          v-model.trim.lazy="$v.bank_acc_type.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.bank_acc_type" :name="$t('ui.bank_acc_type')")
      //- b-form-group(:label="$tc('ui.login_user')" disabled).mb-0
      //-   DebounceInput(
      //-     size="sm"
      //-     type="text"
      //-     :dirty="$v.login_user.$dirty"
      //-     :error="$v.login_user.$error"
      //-     v-model.trim.lazy="$v.login_user.$model"
      //-     :disabled="loading"
      //-   )
      //-   ValidateResult(:value="$v.login_user" :name="$t('ui.login_user')")
      //- b-form-group(:label="$t('ui.login_pwd')" disabled).mb-0
      //-   DebounceInput(
      //-     size="sm"
      //-     type="text"
      //-     :dirty="$v.login_pwd.$dirty"
      //-     :error="$v.login_pwd.$error"
      //-     v-model.trim.lazy="$v.login_pwd.$model"
      //-     :disabled="loading"
      //-   )
      //-   ValidateResult(:value="$v.login_pwd" :name="$t('ui.login_pwd')")
      b-form-group(:label="$tc('ui.account_balance')" disabled).mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.account_balance.$dirty"
          :error="$v.account_balance.$error"
          v-model.trim.lazy="$v.account_balance.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.account_balance" :name="$t('ui.account_balance')")
      div
        b-form-group(:label="$t('ui.threshold')").mb-3
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th
                      span &nbsp;
                    th
                      span {{ $t('ui.amount') }}
                    th
                      span {{ $t('ui.frequency') }}
                tbody
                  tr(v-if="bank_acc_type.toUpperCase() != 'OUTGOING'")
                    td
                      span.font-weight-bold.text-uppercase {{ $t('ui.incoming') }}
                    td
                      DebounceInput(
                        size="sm"
                        ref="incoming_amount_threshold"
                        required
                        type="text"
                        :dirty="$v.incoming_amount_threshold.$dirty"
                        :error="$v.incoming_amount_threshold.$error"
                        v-model.trim.lazy="$v.incoming_amount_threshold.$model"
                        :disabled="loading"
                      )
                      ValidateResult(:value="$v.incoming_amount_threshold" :name="$t('ui.incoming_amount_threshold')")
                    td
                      DebounceInput(
                        size="sm"
                        ref="incoming_frequency_threshold"
                        required
                        type="text"
                        :dirty="$v.incoming_frequency_threshold.$dirty"
                        :error="$v.incoming_frequency_threshold.$error"
                        v-model.trim.lazy="$v.incoming_frequency_threshold.$model"
                        :disabled="loading"
                      )
                      ValidateResult(:value="$v.incoming_frequency_threshold" :name="$t('ui.incoming_frequency_threshold')")
                  tr(v-if="bank_acc_type.toUpperCase() != 'INCOMING'")
                    td
                      span.font-weight-bold.text-uppercase {{ $t('ui.outgoing') }}
                    td
                      DebounceInput(
                        size="sm"
                        ref="outgoing_amount_threshold"
                        required
                        type="text"
                        :dirty="$v.outgoing_amount_threshold.$dirty"
                        :error="$v.outgoing_amount_threshold.$error"
                        v-model.trim.lazy="$v.outgoing_amount_threshold.$model"
                        :disabled="loading"
                      )
                      ValidateResult(:value="$v.outgoing_amount_threshold" :name="$t('ui.outgoing_amount_threshold')")
                    td
                      DebounceInput(
                        size="sm"
                        ref="outgoing_frequency_threshold"
                        required
                        type="text"
                        :dirty="$v.outgoing_frequency_threshold.$dirty"
                        :error="$v.outgoing_frequency_threshold.$error"
                        v-model.trim.lazy="$v.outgoing_frequency_threshold.$model"
                        :disabled="loading"
                      )
                      ValidateResult(:value="$v.outgoing_frequency_threshold" :name="$t('ui.outgoing_frequency_threshold')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankLookup from "@/library/BankLookup";
import BankAccType from "@/library/BankAccType";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankLookup,
    BankAccType
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      bank: "",
      bank_acc_no: "",
      bank_acc_holder: "",
      bank_acc_type: "",
      login_user: null,
      login_pwd: null,
      account_balance: 0,
      incoming_amount_threshold: 0,
      incoming_frequency_threshold: 0,
      outgoing_amount_threshold: 0,
      outgoing_frequency_threshold: 0,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    bank: {
      required
    },
    bank_acc_no: {
      required,
      integer,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    bank_acc_holder: {
      required,
      alphaNumWithSpace,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    bank_acc_type: {
      required
    },
    // login_user: {
    //   alphaNum
    // },
    // login_pwd: {
    //   alphaNum
    // },
    account_balance: {
      decimal,
      required
    },
    incoming_amount_threshold: {
      decimal,
      required
    },
    incoming_frequency_threshold: {
      integer,
      required
    },
    outgoing_amount_threshold: {
      decimal,
      required
    },
    outgoing_frequency_threshold: {
      integer,
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.bankAccountUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          source_account_id: this.$store.getters.accountId,
          target_account_id: this.item.account_id,
          bank_id: this.bank.split(' - ')[0].trim(),
          bank_acc_no: this.bank_acc_no.trim(),
          bank_acc_holder: this.bank_acc_holder,
          bank_acc_type: this.bank_acc_type,
          incoming_amount_threshold: this.incoming_amount_threshold ? this.incoming_amount_threshold : 0.00,
          incoming_frequency_threshold: this.incoming_frequency_threshold ? this.incoming_frequency_threshold : 0,
          outgoing_amount_threshold: this.outgoing_amount_threshold ? this.outgoing_amount_threshold : 0.00,
          outgoing_frequency_threshold: this.outgoing_frequency_threshold ? this.outgoing_frequency_threshold : 0,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editBankAccount.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_bank_account", this.feedback.status);
                  this.$refs.editBankAccount.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.bank = this.item.bank_id.trim().toUpperCase() + ' - ' + this.item.bank_name.trim().toUpperCase();
      this.bank_acc_no = this.item.bank_acc_no;
      this.bank_acc_holder = this.item.bank_acc_holder;
      this.bank_acc_type = this.item.bank_acc_type;
      this.login_user = this.item.login_user;
      this.login_pwd = this.item.login_pwd;
      this.account_balance = this.item.account_balance;
      this.incoming_amount_threshold = this.item.incoming_amount_threshold;
      this.incoming_frequency_threshold = this.item.incoming_frequency_threshold;
      this.outgoing_amount_threshold = this.item.outgoing_amount_threshold;
      this.outgoing_frequency_threshold = this.item.outgoing_frequency_threshold;
      this.$refs.bank_acc_holder.$el.focus();
    }
  }
};
</script>
